import React from "react";
import {
    findLargestPPQ,
    RydProject
} from "../../model/project";
import { CaretController } from "../../utils/ScrollController";
import { useZoomStore } from "../../stores/ZoomStore";
import { normalizeClassName } from "../../render/renderUtils";
import PlaybackCaretIndicatorDialog from "../dialogs/playback/PlaybackCaretIndicatorDialog";
import { GlobalPlaybackControls } from "../dialogs/playback/GlobalPlaybackControls";
import { MetronomeActivityIndicator } from "../pickers/ContextMetronome";
import { Metronome } from "../../model/metronome";
import { ZoomLevelSelector } from "../pickers/ZoomLevelSelector";
import { WorkspaceEditControls } from "./WorkspaceEditControls";
import RydRollHeaderGroup from "../widgets/RydRollHeaderGroup";


export function WorkspacePlaybackControls({
    project,
    caretController,
}: {
    project: RydProject,
    caretController?: CaretController,
}) {
    const zoomStore = useZoomStore();

    return (
        <div className={normalizeClassName(['header-controls', 'global-header-controls', 'piano-roll-header-info-bar'])}
            style={{
                alignItems: 'baseline',
                minHeight: '22px',
                paddingTop: 'var(--top-menus-padding)',
                marginTop: '2px',
            }}>

            <div style={{
                display: 'inline-block',
                position: 'absolute',
                left: '0px',
                marginLeft: 'var(--global-side-margin)',
                textWrap: 'nowrap',
            }}>
                <WorkspaceEditControls />
            </div>

            <div style={{
                display: 'inline-block',
                position: 'absolute',
                right: '0px',
                textWrap: 'nowrap',
            }}>
                <PlaybackCaretIndicatorDialog
                    ticksLength={project.getLength()}
                    ppq={findLargestPPQ(project)}
                    caretController={caretController}
                    contextFrame={project.contextFrame.computed}
                />
                <GlobalPlaybackControls
                    project={project}
                    timeSignature={project.contextFrame.computed.timeSignature}
                    caretController={caretController}
                />
                <RydRollHeaderGroup>
                <MetronomeActivityIndicator
                    metronomeActivityObserver={Metronome.ActivityObserver.getInstance()} />
                    </RydRollHeaderGroup>
                <ZoomLevelSelector
                    value={zoomStore.zoomFactor}
                    setValue={zoomStore.setZoomFactor}
                    referencePPQ={findLargestPPQ(project)}
                />
            </div>
        </div>
    );
}